export default __webpack_public_path__ + "static/media/panner_bg.d6640f53.svg";